import { DataTablePresenter, FilterMethod, ICustomFilter } from '@enter/core';

/** Draft/invoice list APIs expose `filterExternalPatientId` only (not ENTER `filterPatientId`). */
export const PATIENT_ID_FILTER_ID = 'filterExternalPatientId';

export function patientIdSearchFilter(raw?: string): ICustomFilter | undefined {
    const value = (raw || '').trim();
    if (!value) {
        return undefined;
    }
    return {
        filterId: PATIENT_ID_FILTER_ID,
        filterMethod: FilterMethod.EQ,
        filterType: 'String',
        value,
        label: 'Patient ID',
    };
}

export function initialFiltersFromPatientIdSearch(raw?: string): ICustomFilter[] {
    const filter = patientIdSearchFilter(raw);
    return filter ? [filter] : [];
}

export function collectionsSearchEmptyMessage(search: string | undefined, idle: string): string {
    return search?.trim() ? 'No invoices match your search.' : idle;
}

export function applyPatientIdSearch(presenter: DataTablePresenter<any>, raw: string): void {
    const filter = patientIdSearchFilter(raw);
    if (!filter) {
        presenter.findAndRemoveFilter({ filterId: PATIENT_ID_FILTER_ID });
        return;
    }
    presenter.onColumnFilterChange(PATIENT_ID_FILTER_ID, filter);
}

export function syncPatientIdSearch(
    presenter: DataTablePresenter<any>,
    next?: string,
    prev?: string,
): void {
    if ((next || '') === (prev || '')) {
        return;
    }
    applyPatientIdSearch(presenter, next || '');
}
